import { Component, Input, Type, inject } from '@angular/core';

import { DynamicComponentDirective, ExpandableMenuItem, MenuActionsService, MenuContentItem, trackByProp } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    imports: [MenuItemComponent, DynamicComponentDirective, IconCustomComponent],
    selector: 'vn-pc-menu-item',
    templateUrl: 'pc-menu-item.html',
})
export class PCMenuItemComponent {
    private menuActionService = inject(MenuActionsService);

    @Input() item: ExpandableMenuItem;
    @Input() section: string;
    @Input() level: number = 1;
    type: Type<PCMenuItemComponent> = PCMenuItemComponent;
    readonly trackByText = trackByProp<ExpandableMenuItem>('text');

    onClick(event: Event) {
        const action = this.findFirstNonEmpty(this.item);
        if (action && action !== this.item) {
            this.menuActionService.processClick(event, action, this.section);
        }
    }

    private findFirstNonEmpty(item: MenuContentItem): MenuContentItem | undefined {
        if (item.url || item.clickAction) {
            return item;
        }

        if (item.children) {
            for (const child of item.children) {
                const nonEmpty = this.findFirstNonEmpty(child);
                if (nonEmpty) {
                    return nonEmpty;
                }
            }
        }

        return;
    }
}
